(() => {
  // Display only: hide catalog classification numbers such as "09．" and internal categories.
  const NUM = /^(\s*)\d{2}[．.]\s*(?=\S)/;
  const HIDE = /^\s*(?:\d{2}[．.]\s*)?(?:WEB巻末|後付け|その他のシリーズ|その他関連用品)\s*$/;
  const SKIP = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'NOSCRIPT']);
  const clean = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || SKIP.has(parent.tagName) || parent.isContentEditable) return;
      const text = node.nodeValue;
      if (!text || text.length > 80) return;
      if (HIDE.test(text)) {
        const item = parent.closest('li, details, option') || parent.closest('a');
        if (item && item.textContent.trim().length < 40) item.hidden = true;
        return;
      }
      if (text.indexOf('\u2197') > -1) {
        const link = parent.closest('a');
        if (link && link.host === location.host && link.target !== '_blank') { node.nodeValue = text.replace(/\u2197/g, '\u2192'); return; }
      }
      if (NUM.test(text)) node.nodeValue = text.replace(NUM, '$1');
    });
  };
  const run = () => {
    clean(document.body);
    if (NUM.test(document.title)) document.title = document.title.replace(NUM, '$1');
    let timer = null;
    new MutationObserver((list) => {
      if (timer) return;
      timer = setTimeout(() => { timer = null; clean(document.body); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

// Compact sticky header: hide the search bar row while scrolled (CSS limits this to narrow widths).
(() => {
  let on = false;
  const f = () => {
    const y = window.scrollY;
    const next = on ? y > 80 : y > 260;
    if (next !== on) { on = next; document.body.classList.toggle('ace-scrolled', on); }
  };
  window.addEventListener('scroll', f, { passive: true });
  f();
})();

(function(){var n=0;var t=setInterval(function(){var c=document.querySelector("shopify-chat");if(c&&c.shadowRoot&&c.shadowRoot.querySelector(".activator")){if(!c.shadowRoot.querySelector("#aceChatIconOnly")){var s=document.createElement("style");s.id="aceChatIconOnly";s.textContent=".activator__label{display:none!important}.activator{padding:0!important;width:48px!important;min-width:48px!important;height:48px!important;justify-content:center!important;border-radius:50%!important;gap:0!important}";c.shadowRoot.appendChild(s);}}if(n++>120)clearInterval(t);},500);})();
